import {
  DEFAULT_ANCHOR_BY_TYPE,
  ElementState,
  ElementType,
  Rect,
  THICKNESS_PRESETS,
} from '@ritabygglov/core';

export const createRect = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string,
  options: Partial<Rect> = {}
): Rect => {
  return {
    type: ElementType.Rect,
    text: ' ',
    width: 160,
    height: 100,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    style: {
      fill: 'transparent',
      stroke: '#000',
    },
    thickness: THICKNESS_PRESETS.M,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Rect],
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    diagonalHatch: false,
    ...options,
    id,
    x: initialX,
    y: initialY,
  };
};
